module.exports = __webpack_public_path__ + "img/spaceship-00.0e766265.png";